/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoControlCenterModelsPlatform,
    ControlcenterMelcoControlCenterModelsPlatformFromJSON,
    ControlcenterMelcoControlCenterModelsPlatformFromJSONTyped,
    ControlcenterMelcoControlCenterModelsPlatformToJSON,
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsPlatform
 */
export interface ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsPlatform {
    /**
     * 
     * @type {Array<ControlcenterMelcoControlCenterModelsPlatform>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsPlatform
     */
    list: Array<ControlcenterMelcoControlCenterModelsPlatform>;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsPlatform
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsPlatform
     */
    total: number;
}

export function ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsPlatformFromJSON(json: any): ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsPlatform {
    return ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsPlatformFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsPlatform {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ControlcenterMelcoControlCenterModelsPlatformFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsPlatformToJSON(value?: ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsPlatform | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ControlcenterMelcoControlCenterModelsPlatformToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


